"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import Toast from "vwa/components/Toast";
import dispatcher from "./../dispatcher";
import poiCollaborationStore from "./../store/poiCollaborations";
import getPOICollaborations from "./getPOICollaborations";

async function getCollaborations(poiId) {
	let collaborations = poiCollaborationStore.get(poiId).getAll();
	if (!collaborations) {
		await getPOICollaborations(poiId);
		collaborations = poiCollaborationStore.get(poiId).getAll();
		if (!collaborations)
			return [];
	}
	return collaborations;
}

export default async function deletePOI(poiId) {
	try {
		const response = await api.delete("pois", {pois: [poiId]});
		const collaborations = await getCollaborations(poiId);
		await api.delete("pois/collaborations", {
			_id: poiId,
			collaborators: collaborations.map(c => c.collaborator)
		});
		dispatcher.dispatch("removePOI", poiId);
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}


// WEBPACK FOOTER //
// ./src/api/deletePOI.js